import React from "react";
import { useDispatch } from "react-redux/es/hooks/useDispatch";
import { useI18N } from "@src/language/language-context";
import { VerticalSeparator } from "../vertical-separator/vertical-separator";
import requestTechnicalSupportIcon from "@src/assets/svg/support-screen-icon.svg";
import {
  updateAddRequestTechnicalSupportDrawerModal,
  updateModalsCloseDrawerModal,
} from "@src/reducers/your-reducer";
import { IconButton } from "../buttons/icon-button/icon-button";

interface TicketSupportForMachineRowIconButtonProps {
  machineName: string;
  machineID: string;
  machineDSN: string;
}
export const TicketSupportForMachineRowIconButton = ({
  machineName,
  machineID,
  machineDSN,
}: TicketSupportForMachineRowIconButtonProps) => {
  const i18n = useI18N();
  const dispatch = useDispatch();

  const texts = {
    goToRequestTechnicalSupport: i18n(
      "modules.ticketSupportForMachineRowIconButton.goToRequestTechnicalSupport",
    ),
  };

  const handleOpenRequestTechnicalSupportDrawerModal = () => {
    dispatch(
      updateAddRequestTechnicalSupportDrawerModal({
        source_id: "",
        source_dsn: "",
        source_name: "",
      }),
    );

    dispatch(
      updateAddRequestTechnicalSupportDrawerModal({
        source_id: machineID,
        source_dsn: machineDSN,
        source_name: machineName,
      }),
    );
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: false,
        id: "supportChatDrawerModal",
      }),
    );
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: true,
        id: "addRequestTechnicalSupportDrawerModal",
      }),
    );
  };
  return (
    <>
      <VerticalSeparator />
      <IconButton
        fun={() => handleOpenRequestTechnicalSupportDrawerModal()}
        icon={requestTechnicalSupportIcon}
        tooltip={texts.goToRequestTechnicalSupport}
      />
    </>
  );
};
